import  '../config.json'
import api from '../Images/cloud-api.svg';
import map from '../Images/map-small-icon.svg';
import table from '../Images/table-small-icon.svg';
import analytic from '../Images/stats-small-icon.svg';
import info from '../Images/info-small-icon.svg';
import { isRouteErrorResponse } from 'react-router-dom';

var config = require('../config.json');

const getItemVal=(fName,data)=>{
    //if(data!=null && data[fName]!= null && data[fName].Value!=null && data[fName].Value.replace(/(<([^>]+)>)/gi, "")!="")
    if(data!=undefined && data!=null && data[fName]!= null){
        if(data[fName].Value!=null){
            
            const regex = /(<([^>]+)>)/ig;
            var str= data[fName].Value.replace(regex, '').trim();
             
            return str;
   
        }
        
            //return data[fName].Value;
    }
    
    return null;
 };

 const getItemHtmlVal=(fName,data)=>{
    if(data!=null && data[fName]!= null)
        return data[fName].Value.toLocaleLowerCase().replace("href=\"/",`href=\"${window.srcSiteUrl}/`);
    return "";
 };

 const getImageUrl=(fName,data)=>{
   var imageUrl=getItemVal(fName,data);

  return imageUrl!=""?window.srcSiteUrl+imageUrl:"";
  //return imageUrl!=""?process.env.REACT_APP_APIURL+imageUrl:"";

  
    
};

function getTlvLink(str) {
    if (str === undefined || str === '' || str===null)
        return;

    var obj = JSON.parse(str);

    obj.hasVal = true;
    obj.Target = '_blank';

    if (obj.Url == null || obj.Url === '') {
        obj.hasVal = false;
    }
    else if (obj.Url.startsWith('/')) {
        obj.Target = '_self';
    }
    else if (!obj.Url.startsWith('http')) {
        obj.Url = 'http://' + obj.Url;
    }

    return obj;
}
function getUrlField(str){
    var obj=[{Url:'',Caption:''}];
    if(str.indexOf(',')>-1){
        var data=str.split(',');
        obj.Url=data[0];
        obj.Caption=data[1];

    }
    return obj;
}

const buildItemsList=(data) =>{
    if (data.length == 0)
        return null;

    var _items = [data.length];

    for (var i = 0; i < data.length; i++) {
        _items[i] = buildItem(data[i]);
    }

    return _items;
};

const buildItem=(dataItem)=> {
    if (!dataItem)
        return null;

    var _item = {};
    var _fields = dataItem.Fields;
    for (var j = 0; j < _fields.length; j++) {
        _item[_fields[j].InternalName] = _fields[j];
    }

    return _item;
};

const getIcon=(icon)=>{
    switch (icon){
      case "info":return info;
      case "map":return map;
      case "table":return table;
      case "analytic":return analytic;
      case "api":return api;
    }
  }

  const getValueMultiLookup=(value)=>{

    var multiVal = '';
    var allVal = value.split(';#');
    for (var k = 1; k < allVal.length; k+=2) {
        if (multiVal != '')
            multiVal += ', '
        //var val = allVal[k].split(';#');
        multiVal += allVal[k];
    }
    return multiVal;

  }
  
  const converStringTotHtml=(fName,data)=>{
      var value=getItemVal(fName,data);
    var doc =new DOMParser().parseFromString(value, "text/xml");
	
	return doc.firstChild.innerHTML;

    //return value.replace(/<[^>]*>/g, '');
  }



export {getItemVal,getImageUrl,buildItemsList,getIcon,getTlvLink,getUrlField,getValueMultiLookup,converStringTotHtml,getItemHtmlVal}